export default "__VITE_ASSET__b7632c7b__"